// Keys for the memoized Intl dateTime formatters
export const DATE_WITH_TIME_FORMAT = 'DATE_WITH_TIME_FORMAT';
export const DATE_ONLY_FORMAT = 'DATE_ONLY_FORMAT';

export const DEFAULT_DATE_TIME_FORMAT = DATE_WITH_TIME_FORMAT;

export const DATE_TIME_FORMATS = [DATE_WITH_TIME_FORMAT, DATE_ONLY_FORMAT];
